import { ResponseCode } from '@ul/api';

export type PushNotificationFn = (notification: {
    color: 'error' | 'success' | 'warning' | 'info';
    message: string;
    testId: string;
    overrideIconId?: string;
}) => void;

export type PasskeyTranslations = {
    TechnicalDifficulty: string;
    SessionExpired: string;
};

export const handlePasskeyAuthResponse = (
    responseCode: ResponseCode,
    pushNotification: PushNotificationFn,
    translation: PasskeyTranslations,
    onSuccess: () => void
): boolean => {
    if (responseCode === ResponseCode.Successful) {
        onSuccess();
        return true;
    }

    switch (responseCode) {
        case ResponseCode.InvalidCredentials:
        case ResponseCode.Unauthenticated:
            pushNotification({
                color: 'error',
                message: translation.SessionExpired,
                testId: 'passkey-auth-session-expired',
                overrideIconId: 'fill.symbol.triangle-exclamation',
            });
            break;
        default:
            pushNotification({
                color: 'error',
                message: translation.TechnicalDifficulty,
                testId: 'passkey-auth-failed',
                overrideIconId: 'fill.symbol.triangle-exclamation',
            });
    }

    return false;
};
